import React from 'react';

const Events = () => (
  <div style={{ padding: '2rem' }}>
    <h1>Upcoming Events</h1>
    <ul>
      <li>Storytime with Volunteers – May 2, 2026</li>
      <li>Summer Reading Challenge – June 10, 2026</li>
      <li>Children's Book Fair – July 22, 2026</li>
    </ul>
  </div>
);

export default Events;